import { Outlet } from 'react-router';
import PrivateRoute from 'routes/PrivateRoute/PrivateRoute';
import { NotFoundRoute } from './NotFoundRoute.tsx';
import PublicRoute from './PublicRoute/PublicRoute.tsx';
import type { RoutePath } from './Route.types';
import Main from '../components/technical/Main/Main.tsx';
import MainNoAccess from '../components/technical/Main/MainNoAccess.tsx';
import PageShell from '../components/technical/PageShell/PageShell.tsx';
import TermsAndPolicies from '../components/legal/TermsAndPolicies.tsx';
import PrivacyPolicy from '../components/legal/PrivacyPolicy/PrivacyPolicy';
import AutoSigninPage from '../components/management/AutoSigninPage.tsx';
import { hasAccessToAnyApp } from '../accessGuards.ts';
import Drawer from '../components/technical/Drawer/Drawer.tsx';
import { createAppIndexRoute } from './CreateIndexRoute.tsx';
import { marketRoutes } from './MarketRoutes.tsx';
import { portfolioRoutes } from './PortfolioRoutes.tsx';
import { copilotRoutes } from './CopilotRoutes.tsx';
import { operationRoutes } from './OperationRoutes.tsx';
import { managementRoutes } from './ManagementRoutes.tsx';
import { GRouteErrorBoundary } from '../components/technical/errors/GRouteErrorBoundary.tsx';
import { Maintenance } from '../Maintenance.tsx';
import { MaintenanceWrapper } from 'components/MaintenanceWrapper.tsx';
import { UnleashProvider } from 'providers/UnleashProvider.tsx';

export const maintenanceRoutes: RoutePath[] = [
  {
    path: '*',
    element: <Maintenance />,
  },
];

export const routes: RoutePath[] = [
  {
    path: '/',
    element: (
      <Drawer>
        <UnleashProvider>
          <MaintenanceWrapper>
            <Outlet />
          </MaintenanceWrapper>
        </UnleashProvider>
      </Drawer>
    ),
    children: [
      {
        handle: {
          breadcrumb: 'Home',
        },
        index: true,
        element: <PublicRoute redirectOnLoggedInTo="/app" element={<MainNoAccess />} />,
      },
      {
        path: 'legal/privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'signin',
        handle: {
          breadcrumb: 'Sign In',
        },
        element: <AutoSigninPage />,
      },
      {
        path: 'app',
        element: <PrivateRoute to="/" element={<Main />} shouldAllow={hasAccessToAnyApp} />,
        children: [
          marketRoutes,
          portfolioRoutes,
          copilotRoutes,
          operationRoutes,
          managementRoutes,
          {
            handle: { breadcrumb: 'Terms and policies', title: 'Terms and policies' },
            path: 'terms-and-policies',
            element: (
              <PageShell title="Terms and policies">
                <TermsAndPolicies />
              </PageShell>
            ),
          },
          NotFoundRoute,
          createAppIndexRoute({
            pms: '/app/portfolio/dashboard',
            portfolioLab: '/app/copilot/lab/portfolio',
          }),
        ],
      },
    ],
    errorElement: <GRouteErrorBoundary />,
  },
  NotFoundRoute,
];
